import { render, staticRenderFns } from "./DevSessionsIndex.vue?vue&type=template&id=6815c63f&scoped=true&"
import script from "./DevSessionsIndex.vue?vue&type=script&lang=js&"
export * from "./DevSessionsIndex.vue?vue&type=script&lang=js&"
import style0 from "./DevSessionsIndex.vue?vue&type=style&index=0&id=6815c63f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6815c63f",
  null
  
)

export default component.exports